import * as stylex from "@stylexjs/stylex";
import { colors, radii, spacing } from "@softmax/design-system/tokens.stylex";
import type { MouseEventHandler, ReactElement } from "react";
import type {
  SiteNavigationLink,
  SiteNavigationLinkProps,
} from "./site-navigation-types";

export function SiteNavigationAction({
  action,
  renderLink,
  onClick,
}: {
  readonly action: SiteNavigationLink | null;
  readonly renderLink: (props: SiteNavigationLinkProps) => ReactElement;
  readonly onClick?: MouseEventHandler<HTMLAnchorElement> | undefined;
}) {
  return (
    action &&
    renderLink({
      href: action.href,
      onClick,
      ...stylex.props(styles.action),
      children: (
        <span
          {...stylex.props(
            (action.label === "Sign up" || action.label === "Sign in") &&
              styles.signupLabel,
          )}
        >
          {action.label}
        </span>
      ),
    })
  );
}

const styles = stylex.create({
  action: {
    display: "block",
    position: "relative",
    borderRadius: radii.small,
    backgroundColor: colors.action,
    color: colors.foreground,
    paddingInline: spacing.space16,
    paddingBlock: 9,
    fontSize: 13,
    lineHeight: "17px",
    textAlign: "center",
    whiteSpace: "nowrap",
    textDecoration: "none",
    filter: {
      default: "none",
      ":hover": "brightness(0.95)",
      ":active": "brightness(0.9)",
    },
    "::after": {
      content: '""',
      position: "absolute",
      insetInline: 0,
      top: "50%",
      minHeight: 44,
      transform: "translateY(-50%)",
    },
  },
  signupLabel: { display: "block", minWidth: "9ch" },
});
